import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/core';
export var UsageType = /*#__PURE__*/function (_ValueObject) {
  _inherits(UsageType, _ValueObject);

  var _super = _createSuper(UsageType);

  function UsageType() {
    _classCallCheck(this, UsageType);

    return _super.apply(this, arguments);
  }

  _createClass(UsageType, [{
    key: "value",
    get: function get() {
      return this.props.value;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var guard = Guard.againstNullOrUndefined(value, 'Usage type');

      if (!guard.succeeded) {
        var _guard$message;

        return Result.fail((_guard$message = guard.message) !== null && _guard$message !== void 0 ? _guard$message : 'Usage type is required');
      }

      var trimmed = value.trim();

      if (trimmed.length === 0) {
        return Result.fail('Usage type cannot be empty');
      }

      return Result.ok(new UsageType({
        value: trimmed
      }));
    }
  }]);

  return UsageType;
}(ValueObject);